import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ESigningOrderType, IActivityDto } from "core/dto";
import { Subject, combineLatest, distinctUntilChanged, map } from "rxjs";
import { IActivity } from "../../../dto-map/i-activity";
import { RemoteActivityService } from "../../../remotes/remote-activity.service";
import { SignProcessWizardService } from "../../../sign-process-wizard.service";
import { ActivityCollectionService } from "./activity-collection.service";


@Component({
  selector: 'ss-activity-collection',
  templateUrl: './activity-collection.component.html',
  styleUrls: ['./activity-collection.component.css'],
  host: {
    class: 'display-block padding-standard'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityCollectionComponent implements OnInit, AfterViewInit {

  private readonly _destroy = new Subject<void>();

  readonly addingActivitySubject = this._activityCollectionService.addingActivitySubject;

  readonly activitiesSubject = this._activityCollectionService.activitiesSubject;
  readonly showNewActivityButtonSubject = this._activityCollectionService.showNewActivityButtonSubject;
  readonly activitiesGroupedObs = this._activityCollectionService.activitiesGroupedObs;
  readonly dropSubject = this._activityCollectionService.dropSubject;
  readonly activityDragComponentsSubject = this._activityCollectionService.activityDragComponentsSubject
  readonly dragModeSubject = this._activityCollectionService.dragModeSubject;
  readonly moveSubject = this._activityCollectionService.moveSubject;

  readonly activitiesObs = this.activitiesSubject.pipe(
    map(activities => activities.sort(({ orderIndex: first }, { orderIndex: second }) => first - second))
  );

  readonly showGroupsObs = combineLatest([this._signProcessWizardService.processSigningOrderSubject, this.dragModeSubject]).pipe(
    map(([processSigningOrder, dragMode]) => processSigningOrder === ESigningOrderType.custom),
    distinctUntilChanged()
  )

  readonly draggingObs = this.moveSubject.pipe(
    map(Boolean),
    distinctUntilChanged()
  )


  constructor(
    private readonly _activityCollectionService: ActivityCollectionService,
    private readonly _signProcessWizardService: SignProcessWizardService,
    private readonly _remoteActivityService: RemoteActivityService,
  ) {



  }

  ngOnInit(): void {
    this._remoteActivityService.initializeSigningOrderTypeSubscription();
  }

  ngAfterViewInit(): void {

  }

  addNewActivity() {

    this._activityCollectionService.addNewActivity();
  }


  drop(evParams: CdkDragDrop<any>) {

    this.dropSubject.next(evParams);

  }

  trackById(idx: number, [id]: readonly [string, IActivity[]]) {
    return 'activity-item-' + id;
  }


  getGroupIndex([groupIdx]: readonly [string, IActivity[]]) {

    return Number(groupIdx);
  }

  getActivities([_, activities]: readonly [string, IActivity[]]) {
    return activities;
  }


  showGroupDivider(idx: number) {

    const activities = this.activitiesSubject.value;
    const currentActivity = activities[idx];
    const nextActivity = activities[idx + 1];

    const showGroupDivider = currentActivity.orderIndex !== nextActivity?.orderIndex;

    return showGroupDivider;
  }

  trackActivityById(idx: number, activity: IActivityDto) {

    return 'activity-item' + activity.id;
  }


  addSelf() {

    this._activityCollectionService.addSelf()
  }
  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();

  }
}
